// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagPoolModel extends SmartTagModel {
	isPoolEmptyAndUncovered?: boolean;
	isPoolWaterUnsanitary?: boolean;
	isDamaged?: boolean;
	isMissingEquipment?: boolean;
	hasFenceSurrounding?: boolean;
	isLanaiDamaged?: boolean;
	poolType?: any[];

	constructor() {
		super();
		this.isPoolEmptyAndUncovered = false;
		this.isPoolWaterUnsanitary = false;
		this.isDamaged = false;
		this.isMissingEquipment = false;
		this.hasFenceSurrounding = false;
		this.isLanaiDamaged = false;
		this.poolType = [];
	}
}

export class SmartTagPool extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagViewModel
	 */
	public render(data: SmartTagPoolModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v2');
	}

	private getData(data: SmartTagPoolModel): void {

		const title = data.title || data.subCategory || '';
		const isPoolEmptyAndUncovered = data.isPoolEmptyAndUncovered || '';
		const isPoolWaterUnsanitary = data.isPoolWaterUnsanitary || '';
		const isDamaged = data.isDamaged || '';
		const isMissingEquipment = data.isMissingEquipment || '';
		const hasFenceSurrounding = data.hasFenceSurrounding || '';
		const isLanaiDamaged = data.isLanaiDamaged || '';
		const poolTypes = data.poolType || [];
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}
		if (isPoolEmptyAndUncovered !== null && isPoolEmptyAndUncovered) {
			this.addText(`<span title="Pool Empty and Uncovered">Pool Empty and Uncovered</span>`);
		}
		if (isPoolWaterUnsanitary !== null && isPoolWaterUnsanitary) {
			this.addText(`<span title="Water is unsanitary">Water is unsanitary</span>`);
		}
		if (isDamaged !== null && isDamaged) {
			this.addText(`<span title="Pool is damaged">Pool is damaged</span>`);
		}
		if (isMissingEquipment !== null && isMissingEquipment) {
			this.addText(`<span title="Missing equipment">Missing equipment</span>`);
		}
		if (hasFenceSurrounding !== null && hasFenceSurrounding) {
			this.addText(`<span title="Does not have a Fence Surrounding it">Does not have a Fence Surrounding it</span>`);
		}
		if (isLanaiDamaged !== null && isLanaiDamaged) {
			this.addText(`<span title="Lanai is Damaged">Lanai is damaged</span>`);
		}
		if (poolTypes && poolTypes.length > 0) {
			this.addText(`<span title="Pool Type:">Pool Type:</span>`);
			poolTypes.forEach((poolType: any) => {
				this.addText(`<span title="${poolType.typeName}">&nbsp;&nbsp;&nbsp;&nbsp;${poolType.typeName}</span>`);
			});
		}
		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}

}
